import type { PropsWithChildren } from 'react';

interface Props {
  fields?: string[];
  conditions: string | string[];
}

export const ConditionalField = ({
  fields,
  conditions,
  children,
}: PropsWithChildren<Props>) => {
  if (!fields) {
    return children;
  }

  const conditionFieldName = Array.isArray(conditions)
    ? conditions
    : [conditions];
  const hasAtLeastOneField = conditionFieldName.some((name) =>
    fields.includes(name),
  );

  if (!hasAtLeastOneField) {
    return null;
  }

  return children;
};
